export const mensNewIn = "cat/?cid=27110";
export const womensNewIn = "cat/?cid=27108";
